import { API } from "@/lib/api";

export const DEFAULT_SIZES = ["XXS", "XS", "S", "M", "L", "XL"];
export const blankFabric = () => ({ fabric_type: "", name: "", color: "", meters_per_piece: "" });
const cleanFabrics = (list) => (list || []).filter((f) => f.fabric_type || f.name || f.color)
  .map((f) => ({ ...f, meters_per_piece: f.meters_per_piece === "" || f.meters_per_piece == null ? null : Number(String(f.meters_per_piece).replace(",", ".")) }));

export const blankSheet = (season) => ({
  season, name: "", code: "", sizes: [...DEFAULT_SIZES], notes: "",
  cut: { quantities: {}, notes: "" },
  tech: { colors: [], fabrics: [blankFabric()], measures: [{ point: "", values: {} }], accessories: [{ name: "", quantity: "" }], instructions: "" },
});

export const MEASURE_PRESETS = {
  sopra: ["A GIROMANICA DAVANTI", "B GIROMANICA DIETRO", "C SCOLLO DAVANTI", "D SCOLLO DIETRO", "E SPALLA FINITA", "F LUNGHEZZA MANICA",
    "G METÀ TORACE", "H METÀ FONDO", "I METÀ MUSCOLO", "L LUNGHEZZA C D", "SORMONTO DAVANTI"],
  sotto: ["A VITA DAVANTI", "B ELASTICO FINITO", "C CAVALLO DAVANTI", "D CAVALLO DIETRO", "E LUNGH. INT GAMBA", "F METÀ BACINO",
    "G METÀ COSCIA", "H METÀ GINOCCHIO", "I METÀ FONDO", "L ZIP DAV APERTURA"],
};

// Formato Shopify: numero modello + stagione (es. "8001 A26" o "8001-a26"), colore facoltativo
const CODE_RE = /^(\d{3,6})[\s\-_]+([ap]\d{2})(?:[\s\-_]+.+)?$/i;
export const seasonFromCode = (code) => (code || "").trim().match(CODE_RE)?.[2].toUpperCase() || null;
export const codeIssue = (code, season) => {
  const c = (code || "").trim();
  if (!c) return "Manca il codice modello: senza codice il lotto non potrà collegarsi al prodotto su Shopify.";
  const m = c.match(CODE_RE);
  if (!m) return `Il codice "${c}" non segue il formato di Shopify: scrivi numero modello e stagione, es. "8001 A26".`;
  if (season && m[2].toUpperCase() !== season.toUpperCase()) return `Il codice indica la stagione ${m[2].toUpperCase()} ma la scheda è della stagione ${season}.`;
  return null;
};

// Le vecchie "istruzioni di confezione" confluiscono nelle note per il laboratorio
export const labNotes = (s) => [s.notes, s.tech?.instructions].filter((x) => x && x.trim()).join("\n\n");
export const sheetFabrics = (s) => ((s.tech?.fabrics?.length ? s.tech.fabrics : s.cut?.fabrics) || []).filter((f) => f.fabric_type || f.name || f.color);
export const totalPieces = (sheet) => (sheet.sizes || []).reduce((s, z) => s + (Number(sheet.cut?.quantities?.[z]) || 0), 0);
export const fabricMeters = (f, pieces) => (Number(f.meters_per_piece) || 0) * pieces;
export const imageUrl = (s) => (s?.image_path ? `${API}/model-sheets/image/${s.id}?v=${s.image_version || ""}` : null);
const codeNum = (c) => { const m = (c || "").match(/\d+/); return m ? Number(m[0]) : Infinity; };
export const byCode = (a, b) => codeNum(a.code) - codeNum(b.code) || (a.code || "").localeCompare(b.code || "", "it", { numeric: true }) || (a.number || 0) - (b.number || 0);


export const toPayload = (s) => ({
  season: s.season, name: s.name, code: s.code || "", base_size: s.base_size || "", attention: s.attention || "", category: s.category || "", status: s.status || "bozza", sizes: s.sizes || [], notes: s.notes || "",
  cut: {
    fabrics: [],
    quantities: Object.fromEntries((s.sizes || []).map((z) => [z, Number(s.cut?.quantities?.[z]) || 0])),
    notes: s.cut?.notes || "",
  },
  tech: {
    colors: s.tech?.colors || [],
    fabrics: cleanFabrics(s.tech?.fabrics),
    measures: (s.tech?.measures || []).filter((m) => m.point),
    accessories: (s.tech?.accessories || []).filter((a) => a.name),
    instructions: s.tech?.instructions || "", composition: s.tech?.composition || "", care: s.tech?.care || {},
  },
});
